import React from "react";
import { useStore } from "../../store/store";
import usePersistedState from "../../hooks/usePersistedState";

interface UpdateObj {
  equalPanels?: boolean;
  sideLite: string;
  exactConfigImg: string;
  exactConfig: string;
}

const useConfigSelector = (submitPressed: boolean, editQuote: boolean) => {
  const addToQuote = useStore((state) => state.addToQuote);
  const editBtn = useStore((state) => state.isEdit);
  const sideLite = useStore((state) => state.quote.sideLite);

  const handleError = useStore((state) => state.handleError);

  const handleClickSLite = (label: string) => {
    const checked = label === sideLite;

    if (checked) return;

    let update: UpdateObj = {
      exactConfig: "",
      exactConfigImg: "",
      sideLite: label === "None" ? "none" : `Add ${label}`,
    };

    if (label === "None") {
      update["equalPanels"] = false;
    }

    addToQuote(update);
    handleError("sideliteWidthErr", "");
  };

  const [widthMeasureImg, setWidthMeasureImg] = usePersistedState(
    "widthMeasureImg",
    "",
    submitPressed,
    editQuote
  );

  return {
    widthMeasureImg,
    setWidthMeasureImg,
    handleClickSLite,
    editBtn,
    sideLite,
  };
};

export default useConfigSelector;
